import { useTranslation } from 'react-i18next';
import { hubMessages } from './hub-parity';
import { socialMessages } from './social-parity';
import { shopMessages } from './shop-parity';
import { prosMessages } from './pros-parity';
import { refreshMessages } from './refresh-parity';
import { walletMessages } from './wallet-parity';

/** Порядок переводов: ru, en, az. Все новые экраны используют этот namespace. */
const messages = {
  ...refreshMessages,
  ...walletMessages,
  ...prosMessages,
  ...shopMessages,
  ...socialMessages,
  ...hubMessages,
  now: ['Сейчас', 'Now', 'İndi'],
  booking: ['Запись', 'Booking', 'Rezervasiya'],
  photoLimit: ['Изображение до 20 МБ', 'Image up to 20 MB', '20 MB-a qədər şəkil'],
  outgoingCall: ['Исходящий', 'Outgoing', 'Çıxan'],
  incomingCall: ['Входящий', 'Incoming', 'Gələn'],
  missedCall: ['Пропущенный', 'Missed', 'Buraxılmış'],
  audioCall: ['Аудиозвонок', 'Audio call', 'Səsli zəng'],
  videoCall: ['Видеозвонок', 'Video call', 'Video zəng'],
  trimStart: ['Начало фрагмента', 'Trim start', 'Fraqmentin başlanğıcı'],
  trimEnd: ['Конец фрагмента', 'Trim end', 'Fraqmentin sonu'],
  map: ['Карта', 'Map', 'Xəritə'],
  missedCalls: ['Пропущенные', 'Missed', 'Buraxılmış'],
  noAnswer: ['Нет ответа', 'No answer', 'Cavab yoxdur'],
  friends: ['Друзья', 'Friends', 'Dostlar'],
  mapVisibility: ['Видимость на карте', 'Map visibility', 'Xəritədə görünmə'],
  friendsMapTip: [
    'Здесь видны друзья, которые делятся геопозицией.',
    'See friends who share their location here.',
    'Məkanını paylaşan dostları burada görün.',
  ],
  peopleMapTip: [
    'На карте видны люди с включённой геопозицией.',
    'The map shows people who share their location.',
    'Xəritədə məkanını paylaşan insanlar görünür.',
  ],
  address: ['Адрес', 'Address', 'Ünvan'],
  myLocation: ['Моё местоположение', 'My location', 'Mənim yerim'],
  locationPermission: [
    'Разрешите доступ к геопозиции в настройках сайта вашего браузера.',
    'Allow location access in your browser site settings.',
    'Brauzerin sayt ayarlarında məkana girişi aktiv edin.',
  ],
  radius: ['Радиус', 'Radius', 'Radius'],
  notSelected: ['Не выбран', 'Not selected', 'Seçilməyib'],
  km: ['км', 'km', 'km'],
  retry: ['Повторить', 'Retry', 'Yenidən cəhd et'],
  loading: ['Загрузка…', 'Loading…', 'Yüklənir…'],
  empty: ['Пока здесь пусто', 'Nothing here yet', 'Hələ boşdur'],
  error: ['Не удалось загрузить', 'Unable to load', 'Yükləmək mümkün olmadı'],
  save: ['Сохранить', 'Save', 'Yadda saxla'],
  cancel: ['Отмена', 'Cancel', 'Ləğv et'],
  close: ['Закрыть', 'Close', 'Bağla'],
  back: ['Назад', 'Back', 'Geri'],
  next: ['Далее', 'Next', 'Növbəti'],
  more: ['Показать ещё', 'Show more', 'Daha çox göstər'],
  all: ['Все', 'All', 'Hamısı'],
  search: ['Поиск', 'Search', 'Axtarış'],
  filters: ['Фильтры', 'Filters', 'Filtrlər'],
  delete: ['Удалить', 'Delete', 'Sil'],
  edit: ['Изменить', 'Edit', 'Dəyiş'],
  create: ['Создать', 'Create', 'Yarat'],
  undo: ['Отменить', 'Undo', 'Geri qaytar'],
  confirm: ['Подтвердить', 'Confirm', 'Təsdiqlə'],
  copied: ['Ссылка скопирована', 'Link copied', 'Link kopyalandı'],
  share: ['Поделиться', 'Share', 'Paylaş'],
  copy: ['Копировать', 'Copy', 'Kopyala'],
  selected: ['Выбрано: {{count}}', 'Selected: {{count}}', 'Seçilib: {{count}}'],
  unknown: [
    'Результат операции уточняется. Повторная отправка заблокирована.',
    'The result is being checked. Sending again is blocked.',
    'Əməliyyatın nəticəsi yoxlanılır. Təkrar göndərmə bloklanıb.',
  ],
  checkStatus: ['Проверить статус', 'Check status', 'Statusu yoxla'],
  chats: ['Чаты', 'Chats', 'Çatlar'],
  newChat: ['Новый чат', 'New chat', 'Yeni çat'],
  chatUnavailable: ['Чат недоступен', 'Chat unavailable', 'Çat əlçatmazdır'],
  noContacts: ['Нет контактов', 'No contacts', 'Kontakt yoxdur'],
  contacts: ['Контакты', 'Contacts', 'Kontaktlar'],
  pros: ['Профи', 'Professionals', 'Mütəxəssislər'],
  shop: ['Магазин', 'Shop', 'Mağaza'],
  dating: ['Знакомства', 'Dating', 'Tanışlıq'],
  groups: ['Группы', 'Groups', 'Qruplar'],
  rooms: ['Комнаты', 'Rooms', 'Otaqlar'],
  groupTitle: ['Название группы', 'Group title', 'Qrupun adı'],
  newGroup: ['Создать группу', 'Create group', 'Qrup yarat'],
  members: ['Участники', 'Members', 'İştirakçılar'],
  addMembers: ['Добавить участников', 'Add members', 'İştirakçı əlavə et'],
  leave: ['Выйти', 'Leave', 'Çıx'],
  join: ['Вступить', 'Join', 'Qoşul'],
  preview: ['Предпросмотр', 'Preview', 'Önizləmə'],
  select: ['Выбрать', 'Select', 'Seç'],
  read: ['Отметить прочитанным', 'Mark as read', 'Oxunmuş kimi işarələ'],
  unread: ['Отметить непрочитанным', 'Mark as unread', 'Oxunmamış kimi işarələ'],
  mute: ['Без звука', 'Mute', 'Səssiz'],
  unmute: ['Включить звук', 'Unmute', 'Səsi aç'],
  hour: ['На 1 час', 'For 1 hour', '1 saat'],
  eightHours: ['На 8 часов', 'For 8 hours', '8 saat'],
  day: ['На 1 день', 'For 1 day', '1 gün'],
  week: ['На неделю', 'For a week', '1 həftə'],
  forever: ['Навсегда', 'Forever', 'Həmişəlik'],
  pin: ['Закрепить', 'Pin', 'Bərkit'],
  unpin: ['Открепить', 'Unpin', 'Bərkitməni ləğv et'],
  pinLimit: [
    'Можно закрепить не больше 5 чатов',
    'You can pin up to 5 chats',
    'Ən çox 5 çat bərkitmək olar',
  ],
  archive: ['Архивировать', 'Archive', 'Arxivlə'],
  deleted: ['Удалено', 'Deleted', 'Silindi'],
  deleteChats: [
    'Удалить выбранные чаты? Это нельзя отменить.',
    'Delete selected chats? This cannot be undone.',
    'Seçilmiş çatlar silinsin? Bunu geri qaytarmaq olmaz.',
  ],
  purge: [
    'Очистить историю у обоих',
    'Clear history for both',
    'Hər iki tərəfdə tarixçəni sil',
  ],
  message: ['Сообщение…', 'Message…', 'Mesaj…'],
  send: ['Отправить', 'Send', 'Göndər'],
  reply: ['Ответить', 'Reply', 'Cavab ver'],
  forward: ['Переслать', 'Forward', 'Yönləndir'],
  forwarded: [
    'Переслано от {{name}}',
    'Forwarded from {{name}}',
    '{{name}} tərəfindən yönləndirilib',
  ],
  hideSender: ['Скрыть имя отправителя', 'Hide sender name', 'Göndərənin adını gizlət'],
  hideSenderUnavailable: [
    'Для этих типов сообщений скрытие отправителя недоступно',
    'Hiding the sender is unavailable for these message types',
    'Bu mesaj növlərində göndərəni gizlətmək mümkün deyil',
  ],
  comment: ['Комментарий', 'Comment', 'Şərh'],
  sending: ['Отправляется', 'Sending', 'Göndərilir'],
  failed: ['Не отправлено', 'Not sent', 'Göndərilmədi'],
  uncertain: ['Статус не подтверждён', 'Status unconfirmed', 'Status təsdiqlənməyib'],
  edited: ['изменено', 'edited', 'dəyişdirilib'],
  deletedMessage: ['Сообщение удалено', 'Message deleted', 'Mesaj silinib'],
  decryptionFailed: [
    'Не удалось расшифровать',
    'Unable to decrypt',
    'Şifrəni açmaq mümkün olmadı',
  ],
  deleteMessages: ['Удалить сообщения?', 'Delete messages?', 'Mesajlar silinsin?'],
  forEveryone: [
    'Удалить также у собеседника',
    'Also delete for the other person',
    'Qarşı tərəfdə də sil',
  ],
  latest: ['К последним', 'Jump to latest', 'Son mesajlara keç'],
  noResults: ['Ничего не найдено', 'No results', 'Nəticə tapılmadı'],
  inChat: ['В чате', 'In chat', 'Çatda'],
  asList: ['Списком', 'As list', 'Siyahı şəklində'],
  photo: ['Фото', 'Photo', 'Şəkil'],
  media: ['Фото и видео', 'Photos and videos', 'Şəkillər və videolar'],
  audio: ['Голосовое', 'Voice message', 'Səsli mesaj'],
  circle: ['Видеосообщение', 'Video message', 'Video mesaj'],
  file: ['Файл', 'File', 'Fayl'],
  location: ['Геопозиция', 'Location', 'Məkan'],
  contact: ['Контакт', 'Contact', 'Kontakt'],
  gift: ['Подарок', 'Gift', 'Hədiyyə'],
  transfer: ['Перевод', 'Transfer', 'Köçürmə'],
  story: ['История', 'Story', 'Hekayə'],
  call: ['Звонок', 'Call', 'Zəng'],
  callBack: ['Перезвонить', 'Call back', 'Geri zəng et'],
  calls: ['История звонков', 'Call history', 'Zəng tarixçəsi'],
  profile: ['Профиль', 'Profile', 'Profil'],
  write: ['Написать', 'Message', 'Yaz'],
  online: ['В сети', 'Online', 'Onlayn'],
  attachmentLimit: [
    'До 10 вложений, каждый файл от 1 байта до 100 МиБ',
    'Up to 10 attachments, each from 1 byte to 100 MiB',
    'Ən çox 10 əlavə, hər fayl 1 baytdan 100 MiB-a qədər',
  ],
  forwardLimit: [
    'Можно переслать до 50 сообщений',
    'You can forward up to 50 messages',
    'Ən çox 50 mesaj yönləndirmək olar',
  ],
  recordingShort: [
    'Запись должна длиться не меньше 1 секунды',
    'Recording must be at least 1 second',
    'Yazı ən azı 1 saniyə olmalıdır',
  ],
} satisfies Record<string, readonly [string, string, string]>;

export const parityResources = Object.fromEntries(
  ['ru', 'en', 'az'].map((lang, index) => [
    lang,
    Object.fromEntries(
      Object.entries(messages).map(([key, value]) => [key, value[index]])
    ),
  ])
);
export function useParityT() {
  return useTranslation('parity').t;
}
